import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconSolverTrajectorySizeM from './IconSolverTrajectory_size_m';

const props: CreateIconArguments = {
  l: IconSolverTrajectorySizeM,
  m: IconSolverTrajectorySizeM,
  s: IconSolverTrajectorySizeM,
  xs: IconSolverTrajectorySizeM,
  name: 'IconSolverTrajectory',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
